import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// F5: AI assistant. Owned by the ai module. The ticket screen embeds ticket-panel.tsx; the
// settings page is mounted by the admin layout (modules/admin/routes.tsx).
export const routes: RouteObject[] = [{ path: 'ask', lazy: page(() => import('./ask-page'), (m) => m.AskPage) }];

export const orgRoutes: RouteObject[] = [];

export const settingsRoutes: RouteObject[] = [{ path: 'ai', lazy: page(() => import('./settings-page'), (m) => m.AiSettingsPage) }];
